import { useCallback } from 'react';
import {
  ChipField,
  Edit,
  Labeled,
  SaveButton,
  SimpleForm,
  TextInput,
  Toolbar,
  required,
  useGetIdentity,
  useRecordContext,
} from 'react-admin';
import { MarkdownField } from '../../components/MarkdownField';

export const AppDocumentsEdit = () => {
  const userId = useGetIdentity().data?.id?.toString();

  const transform = useCallback(
    ({ id, ...data }: any) => {
      console.log('data', data);

      return {
        _id: id,
        ...data,
        updatedBy: userId,
        updatedAt: new Date(),
      };
    },
    [userId],
  );

  return (
    <Edit
      title={<EditTitle />}
      mutationMode="pessimistic"
      actions={false}
      transform={transform}
      queryOptions={{ meta: { raw: true } }}
      mutationOptions={{ meta: { raw: true } }}
    >
      <SimpleForm toolbar={<EditToolbar />}>
        <Labeled label="Id">
          <ChipField source="id" />
        </Labeled>
        <br />
        <TextInput
          label="Title"
          source="title"
          validate={[required()]}
          fullWidth
        />
        <MarkdownField label="Page Content" source="content" />
      </SimpleForm>
    </Edit>
  );
};

export const EditToolbar = () => (
  <Toolbar>
    <SaveButton label="Save" />
  </Toolbar>
);

export const EditTitle = () => {
  const record = useRecordContext();

  return <span>App Document: {record ? `${record.id}` : ''}</span>;
};
